function isSelectedContact(selectedContact, currentContact) {
  if (!selectedContact && !currentContact) return false;
  return selectedContact?._id === currentContact?._id;
}

export default isSelectedContact;
